import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
const classnames = classModuleGenerator(styles)

function Reason(props) {
  const reasonList = [
    "22年教育经验",
    "A股上市公司",
    "100+*覆盖城市",
    "200万+*累计学员",
    "4000+*专职教师",
    "个性化教学体系",
    "科学性课程安排",
    "知名教育品牌",
  ]
  return (
    <section className={classnames("reason-container")}>
      <h3 className="section__title">学大中职</h3>
      <div className="section__inner">
        <ul className={styles["reason-list"]}>
          {reasonList.map((m, index) => {
            return (
              <li
                key={m}
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                <div>0{index + 1}</div>
                <h5>{m}</h5>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Reason
